import qs from 'qs';

import type { TrackingFn } from '@change-corgi/core-react/tracking';

import { openUrlWithHiddenAnchor } from '#src/app/shared/share/utils';

import { trackShareSuccess } from './track';

type Options = {
	trackingData: Record<string, string | number | boolean | undefined>;
	trackingEvents: {
		success: string;
	};
};

export function shareVk(
	url: string,
	title: string,
	{ trackingEvents, trackingData }: Options,
	track: TrackingFn,
): void {
	const params = {
		...(title ? { title } : {}),
		url,
	};

	const vkUrl = `https://vk.com/share.php?${qs.stringify(params, { encodeValuesOnly: true })}`;
	openUrlWithHiddenAnchor(vkUrl, { newTab: true });
	trackShareSuccess(trackingEvents.success, trackingData, track);
}
